export const logoutUrl = () => '/logout';
export const loginUrl = () => '/login';
export const accessDeniedUrl = () => '/access-denied';
export const questionnaireUrl = (id: string) => `/questionnaire/${id}`;
